import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {settlementSelector, useGetSettlementQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useEffect, useMemo, useState} from "react";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {SettlementProfile} from "../../components/profile/SettlementProfile/SettlementProfile";
import {useApp} from "../../providers/RegionProvider/RegionProvider";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const SettlementProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage message={"Settlement Not Found"}/>
    );
  }

  return <SettlementProfilePage id={id}/>;
};

export const SettlementProfilePage = (props: Props) => {
  const {id} = props;

  const navigate = useNavigate()
  const {pathname, search, state} = useLocation()
  const {appCategory} = useApp()

  const [access, setAccess] = useState(false);

  useEffect(() => {
    navigate(pathname + search, {replace: true, state: {...state, category: appCategory?.code}})
  }, [])

  const selectSettlement = useMemo(() => {
    return settlementSelector()
  }, []);

  const {settlement, isFetching, error} = useGetSettlementQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      settlement: selectSettlement(result),
      isFetching: result.isFetching,
      error: result.error,
    })
  });

  return (
    <EntityProfilePage
      permissions={["settlement_view"]}
      entity={settlement}
      isLoading={isFetching}
      error={error}
      onAccess={setAccess}>
      {(entity) => (
        <SettlementProfile settlement={entity}/>
      )}
    </EntityProfilePage>
  )
};
